/**
 * Abstraction over react-hot-reload library
 */
import {toast as hrToast } from "react-hot-toast";
import clsx from "clsx";

export function toast(message: string): void {
//   hrToast(
//     (t) => (
//       <span className="bg-red-300">
//         {message}
//       </span>
// )
//   );

  hrToast.custom((t) => (
    <div
      className={clsx(

      `${t.visible ? 'animate-enter' : 'animate-leave'}`,
        "py-2 px-6 bg-white dark:bg-slate-600 text-slate-800 dark:text-slate-100 shadow-lg rounded-lg",
        "pointer-events-auto flex ring-1 ring-black/5"
        )}
    >
      {message}
    </div>
  ))

}